import { createFileRoute, redirect } from '@tanstack/react-router'

/**
 * A topic has no page of its own — the edit wizard IS the topic's page — but the breadcrumb links
 * every ancestor path (".../ Main Topic / Edit" links "Main Topic" here), and an intermediate path
 * with no route is a blank page. Redirect to the wizard, the same convention as /app/access
 * landing on its default tab.
 */
export const Route = createFileRoute('/app/accounts/$accountId_/topics/$subaccountId/$topicId/')({
  loader: ({ params }) => {
    throw redirect({
      to: '/app/accounts/$accountId/topics/$subaccountId/$topicId/edit',
      params,
    })
  },
})
